module.exports = __webpack_public_path__ + "static/media/galerija_2021 (16)-min.262c1f8e.jpg";